<template>
  <div class="selects">
    <div
      :class="{selects0show: !isshow,selects0hade: isshow}"
      class="selects0"
      @click="isshow=!isshow"
    >
      <p ref="mybox">请选择</p>
        <img src="../../assets/2.png" alt srcset />
    </div>
    <div ref="myselect" :class="{show: !isshow,hade: isshow}" class="sel">
      <div
        @click="cutValue(1)"
        ref="mybox1"
        :class="{borders:num ==1}"
        :style="{display: num >=1?'block':'none'}"
      >{{selects1}}</div>
      <div
        @click="cutValue(2)"
        ref="mybox2"
        :class="{borders:num ==2}"
        :style="{display: num >=2?'block':'none'}"
      >{{selects2}}</div>
      <div
        @click="cutValue(3)"
        ref="mybox3"
        :class="{borders:num ==3}"
        :style="{display: num >=3?'block':'none'}"
      >{{selects3}}</div>
      <div
        @click="cutValue(4)"
        ref="mybox4"
        :class="{borders:num ==4}"
        :style="{display: num >=4?'block':'none'}"
      >{{selects4}}</div>
      <div
        @click="cutValue(5)"
        ref="mybox5"
        :class="{borders:num ==5}"
        :style="{display: num >=5?'block':'none'}"
      >{{selects5}}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    num: String, // 显示多少个下拉框
    selects1: String, // 列表里的文字
    selects2: String,
    selects3: String,
    selects4: String,
    selects5: String
  },
  data () {
    return {
      isshow: true // 控制下拉框显示及隐藏
    }
  },
  methods: {
    // 点击换文字的方法
    cutValue (val) {
      let _this = this
      cutfun(val)
      _this.isshow = true
      function cutfun (val) {
        if (val === 1) {
          _this.$refs.mybox.innerText = _this.$refs.mybox1.innerText
          _this.$router.push({name: 'editMainDateText'})
        } else if (val === 2) {
          _this.$refs.mybox.innerText = _this.$refs.mybox2.innerText
          _this.$router.push({name: 'editMainDatePic'})
        } else if (val === 3) {
          _this.$refs.mybox.innerText = _this.$refs.mybox3.innerText
          _this.$router.push({name: 'editMainDateAll'})
        } else if (val === 4) {
          _this.$refs.mybox.innerText = _this.$refs.mybox4.innerText
        } else if (val === 5) {
          _this.$refs.mybox.innerText = _this.$refs.mybox5.innerText
        }
        _this.$emit('va', val, _this.$refs.mybox.innerText)
      }
    }
  }
}
</script>

<style   scoped>
.show {
  display: block;
}
.hade {
  display: none;
}

.selects0show {
  border: 1px solid #e4e4e4;
}

.selects0hade {
  border: 1px solid #e4e4e4;
}

.borders {
  border-bottom: 1px solid #e4e4e4 !important;
}

.traing{
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 10px solid #666666;
}

.selects {
  width: 100%;
  height: 35px;
}
.selects  .selects0 {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    }

.selects0  p {
      line-height: 100%;
      display: inline;
      color: #666666;
      font-size: 15px;
      padding-left: 10px;
    }
.selects0 img {
      margin-right: 10px;
      transform: translateY(-2px);
    }

  .sel {
    width: 96%;
    height: 100%;
    font-size: 15px;
  }
    .sel  div {
      width: 100%;
      /* height: 100%; */
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 35px;
      border: 1px solid #e4e4e4;
      border-top: none;
      padding-left: 10px;
      border-bottom: none;
      background: white;
    }
 .sel div:hover {
      background: #fff8f8;
      color: #666666;
    }
.sel .selects0:hover {
      background: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/selects.vue